import { render } from "./SidebarSub.vue?vue&type=template&id=8a052654"
import script from "./SidebarSub.vue?vue&type=script&lang=js"
export * from "./SidebarSub.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__